import useSalonDashboardController from "@admin/api/useSalonDashboardController"
import useSalonEbookController from "@admin/api/useSalonEbookController"
import useSalonLimitController from "@admin/api/useSalonLimitController"
import useSalonNotificationController from "@admin/api/useSalonNotificationController"
import useSalonParticipationController from "@admin/api/useSalonParticipationController"
import useSalonPaymentController from "@admin/api/useSalonPaymentController"
import useSalonPromoController from "@admin/api/useSalonPromoController"
import useSalonTrackingController from "@admin/api/useSalonTrackingController"

export default function useApi(
    id: string | number,
    controller: Admin.Controllers.Salon
): Admin.Models.Salon.Api {
    const destroy = () => controller.destroy(id)
    const customers = controller.customers(id)
    const juries = controller.juries(id)
    const best = (userId: string | number) => controller.best(id, userId)
    const type = (type: Attributes.Salon.Type) => controller.type(id, type)

    const promoController = useSalonPromoController(id)
    const promos = promoController.index

    const paymentController = useSalonPaymentController(id)
    const payments = paymentController.index
    
    const participations = useSalonParticipationController(id)
    const notifications = useSalonNotificationController(id)
    const dashboard = useSalonDashboardController(id)
    const ebook = useSalonEbookController(id)
    const limit = useSalonLimitController(id)
    const tracking = useSalonTrackingController(id)

    return {
        destroy,
        ebook,
        customers,
        participations,
        dashboard,
        limit,
        juries,
        payments,
        promos,
        notifications,
        best,
        type,
        tracking
    }
}